import {
  LitElement,
  css,
  html,
} from "https://cdn.jsdelivr.net/gh/lit/dist@3/core/lit-core.min.js";

class SkioAddToSubscription extends LitElement {
  static styles = css`
    :host {
      --color-primary: var(--skio-primary-color, var(--color-1-scale-500, #425941)); 
      --color-accent: var(--color-neutral-100, #FBF7EE);
      --color-bg: var(--color-neutral-200, #F3EFE5); 
      --color-card-bg: var(--color-neutral-100, #FBF7EE); 
      --color-border: var(--color-neutral-300, #E7E2D7); 
      --color-border-dark: var(--color-neutral-500, #CEC6AF); 
      --color-text: var(--color-1-scale-800, #202C20); 
      --color-muted: rgba(32, 44, 32, 0.75); 
      --color-strikethrough: rgba(32, 44, 32, 0.45); 
      --border-radius: var(--spacer-2, 0.5rem);
      --button-border-radius: var(--style-border-radius-buttons-primary, 2.875rem);

      position: relative;
      display: block;
      font-family: var(--font-body--family, 'Lazzer', sans-serif);
      font-size: var(--font-size--sm, 0.875rem);
      margin-top: var(--spacer-4, 1rem);
      margin-bottom: var(--spacer-4, 1rem);
      width: 100%;
      box-sizing: border-box;
    }

    .callout {
      background: var(--color-bg, #F3EFE5);
      border-radius: var(--border-radius, 0.5rem);
      padding: var(--spacer-4, 1rem);
      margin-bottom: 0;
      border: 1px solid var(--color-border-dark, #CEC6AF);
      position: relative;
      box-sizing: border-box;
    }

    .callout-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: var(--spacer-3, 0.75rem);
      margin-bottom: var(--spacer-3, 0.75rem);
    }

    .callout-title-group {
      display: flex;
      flex-direction: column;
      gap: 0.125rem;
    }

    .callout-title {
      margin: 0;
      font-family: var(--font-body--family, 'Lazzer', sans-serif);
      font-size: 0.875rem;
      font-weight: 500;
      color: var(--color-text, #202C20);
      line-height: 1.3;
      margin-bottom: .5rem;
    }

    .callout-date {
      margin: 0;
      font-family: var(--font-body--family, 'Lazzer', sans-serif);
      font-size: var(--font-size--sm, 0.875rem);
      color: var(--color-muted, rgba(32, 44, 32, 0.75));
      line-height: 1.3;
    }

    .callout-pricing-group {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 0.25rem;
      flex-shrink: 0;
    }

    .callout-badge {
      background-color: var(--truemed-bg, #6D161F);
      color: var(--truemed-text, #FBF7EE);
      font-family: var(--font-subheading--family, 'Lazzer', sans-serif);
      font-size: var(--font-size--xs, 0.75rem);
      font-weight: 700;
      line-height: 1;
      padding: 0.3125rem 0.5rem;
      border-radius: 4px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      letter-spacing: normal
      white-space: nowrap;
      margin-bottom: .5rem
    }

    .callout-prices {
      display: flex;
      align-items: center;
      gap: var(--spacer-2, 0.5rem);
      line-height: 1.2;
    }

    .callout-price-old {
      text-decoration: line-through;
      color: var(--color-strikethrough, rgba(32, 44, 32, 0.45));
      font-size: var(--font-size--sm, 0.875rem);
      font-weight: 500;
    }

    .callout-price-new {
      color: var(--color-text, #202C20);
      font-size: var(--font-size--base, 1rem);
      font-weight: 500;
    }

    .skio-subscription-items {
      font-size: var(--font-size--xs, 0.75rem);
      color: var(--color-text);
    }

    .add-to-subscription-button {
      background: var(--color-primary);
      color: var(--color-accent);
      border: none;
      border-radius: var(--button-border-radius);
      padding: var(--spacer-3, 0.75rem) var(--spacer-5, 1.25rem);
      width: 100%;
      font-family: var(--font-subheading--family, 'Lazzer', sans-serif);
      font-size: var(--font-size--sm, 0.875rem);
      font-weight: 700;
      letter-spacing: var(--letter-spacing-sm, 0.05em);
      cursor: pointer;
      transition: background-color 0.2s ease, transform 0.1s ease;
      text-transform: uppercase;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      min-height: 2.875rem;
    }

    .add-to-subscription-button:hover {
      background: var(--color-1-scale-600, #344633);
    }

    dialog {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0;
      z-index: var(--layer-temporary, 2147483647);
      background: var(--color-accent);
      border-radius: var(--spacer-3, 0.75rem);
      border: 1px solid var(--color-border);
      width: calc(100% - 2rem);
      max-width: 30rem;
      padding: 0;
      box-shadow: 0 1rem 2.5rem rgba(0, 0, 0, 0.15);
      font-family: var(--font-body--family, 'Lazzer', sans-serif);
      color: var(--color-text);
      overflow: hidden;
      box-sizing: border-box;
    }

    dialog::backdrop {
      background: rgba(0, 0, 0, 0.5);
      -webkit-backdrop-filter: blur(0.125rem);
      backdrop-filter: blur(0.125rem);
    }

    .modal-content {
      position: relative;
      background: var(--color-neutral-100, #FBF7EE);
    }

    .modal-header {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      gap: var(--spacer-2, 0.5rem);
      padding: var(--spacer-4, 1rem);
      border-bottom: 1px solid var(--color-border);
      box-sizing: border-box;
    }

    .modal-title {
      font-family: var(--font-heading--family, 'Reckless Standard S', serif);
      font-size: var(--font-size--lg, 1.25rem);
      font-weight: 400;
      color: var(--color-text);
      margin: 0;
      line-height: 1.2;
    }

    .modal-header .date-badge {
      width: 100%;
      font-size: var(--font-size--xs, 0.75rem);
      color: var(--color-muted);
      font-weight: 500;
    }

    .close-button {
      background: none;
      border: none;
      font-size: 1.5rem;
      color: var(--color-muted);
      cursor: pointer;
      padding: 0;
      margin: 0;
      width: 2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      border-radius: 50%;
      transition: background-color 0.2s ease, color 0.2s ease;
    }

    .close-button:hover {
      background-color: var(--color-neutral-200, #F3EFE5);
      color: var(--color-text);
    }

    form {
      padding: var(--spacer-4, 1rem);
      display: flex;
      flex-direction: column;
      gap: var(--spacer-3, 0.75rem);
      box-sizing: border-box;
    }

    .option-label {
      display: flex;
      align-items: center;
      gap: var(--spacer-3, 0.75rem);
      background: var(--color-neutral-100, #FBF7EE);
      border: 1px solid var(--color-border);
      border-radius: var(--spacer-2, 0.5rem);
      padding: var(--spacer-3, 0.75rem);
      cursor: pointer;
      transition: border-color 0.2s ease, background-color 0.2s ease;
      position: relative;
      box-sizing: border-box;
    }

    .option-label:hover {
      border-color: var(--color-1-scale-500, #425941);
    }

    .option-label.selected {
      border: 2px solid var(--color-1-scale-500, #425941);
      background: var(--color-neutral-200, #F3EFE5);
    }

    .option-label input[type="radio"] {
      accent-color: var(--color-1-scale-500, #425941);
      width: 1.25rem;
      height: 1.25rem;
      flex-shrink: 0;
      margin: 0;
    }

    .option-content {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: var(--spacer-1, 0.25rem);
    }

    .option-title {
      font-size: var(--font-size--sm, 0.875rem);
      font-weight: 700;
      color: var(--color-text);
    }

    .delivery-policy {
      font-size: var(--font-size--xs, 0.75rem);
      color: var(--color-muted);
      font-weight: 500;
      text-transform: capitalize;
    }

    .discount-badge {
      background: var(--color-1-scale-500, #425941);
      color: var(--color-neutral-100, #FBF7EE);
      font-weight: 700;
      border-radius: var(--spacer-1, 0.25rem);
      padding: 0.125rem 0.5rem;
      font-size: var(--font-size--xs, 0.75rem);
      text-transform: uppercase;
      letter-spacing: var(--letter-spacing-sm, 0.05em);
    }

    .price-container {
      margin-left: auto;
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 0.125rem;
    }

    .original-price {
      text-decoration: line-through;
      color: var(--color-strikethrough);
      font-size: var(--font-size--xs, 0.75rem);
      font-weight: 500;
    }

    .discounted-price {
      color: var(--color-1-scale-800, #202C20);
      font-size: var(--font-size--sm, 0.875rem);
      font-weight: 700;
    }

    .modal-policy {
      font-size: var(--font-size--xs, 0.75rem);
      color: var(--color-muted);
      padding: 0 var(--spacer-4, 1rem) var(--spacer-4, 1rem) var(--spacer-4, 1rem);
      line-height: 1.4;
    }

    .modal-policy a {
      color: var(--color-1-scale-500, #425941);
      text-decoration: underline;
    }

    .modal-footer {
      display: flex;
      flex-direction: column;
      gap: var(--spacer-2, 0.5rem);
      padding: var(--spacer-4, 1rem);
      border-top: 1px solid var(--color-border);
      box-sizing: border-box;
    }

    .modal-footer button {
      width: 100%;
      padding: var(--spacer-3, 0.75rem) var(--spacer-5, 1.25rem);
      border-radius: var(--button-border-radius);
      font-family: var(--font-subheading--family, 'Lazzer', sans-serif);
      font-size: var(--font-size--sm, 0.875rem);
      font-weight: 700;
      border: none;
      cursor: pointer;
      transition: background-color 0.2s ease, opacity 0.2s ease;
      text-transform: uppercase;
      letter-spacing: var(--letter-spacing-sm, 0.05em);
      min-height: 2.875rem;
      box-sizing: border-box;
    }

    .primary-button {
      background: var(--color-primary);
      color: var(--color-accent);
    }

    .primary-button:hover:not(:disabled) {
      background: var(--color-1-scale-600, #344633);
    }

    .secondary-button {
      background: var(--color-neutral-200, #F3EFE5);
      color: var(--color-text);
      border: none;
    }

    .secondary-button:hover:not(:disabled) {
      background: var(--color-neutral-300, #E7E2D7);
    }

    .success-screen {
      background: var(--color-neutral-200, #F3EFE5);
      border: 1px solid var(--color-1-scale-300, #8BA98A);
      border-radius: var(--border-radius);
      padding: var(--spacer-4, 1rem);
      margin-bottom: var(--spacer-4, 1rem);
      text-align: left;
      box-sizing: border-box;
    }

    .success-title {
      font-family: var(--font-subheading--family, 'Lazzer', sans-serif);
      font-size: var(--font-size--base, 1rem);
      font-weight: 700;
      color: var(--color-text);
      margin: 0 0 var(--spacer-2, 0.5rem) 0;
      text-transform: uppercase;
      letter-spacing: var(--letter-spacing-sm, 0.05em);
    }

    .success-message {
      font-size: var(--font-size--sm, 0.875rem);
      color: var(--color-text);
      margin: 0 0 var(--spacer-2, 0.5rem) 0;
      line-height: 1.4;
    }

    .success-date {
      font-weight: 700;
      color: var(--color-1-scale-800, #202C20);
    }

    .success-link {
      color: var(--color-1-scale-500, #425941);
      text-decoration: none;
      font-weight: 700;
      font-size: var(--font-size--sm, 0.875rem);
      margin-top: var(--spacer-3, 0.75rem);
      display: inline-block;
      transition: color 0.2s ease;
    }

    .success-link:hover {
      color: var(--color-1-scale-600, #344633);
      text-decoration: underline;
    }

    .loading-spinner {
      display: inline-block;
      width: 1rem;
      height: 1rem;
      border: 0.125rem solid var(--color-accent);
      border-radius: 50%;
      border-top-color: transparent;
      animation: spin 1s linear infinite;
      margin-right: var(--spacer-2, 0.5rem);
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    .primary-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .error-message {
      background: #fee;
      border: 1px solid #fcc;
      border-radius: var(--border-radius);
      padding: var(--spacer-3, 0.75rem);
      margin-bottom: var(--spacer-3, 0.75rem);
      color: var(--color-error, #8B0000);
      font-size: var(--font-size--sm, 0.875rem);
      text-align: center;
    }

    @media(max-width: 500px) {
      .modal-footer {
        flex-direction: column;
        gap: var(--spacer-2, 0.5rem);
        padding: var(--spacer-3, 0.75rem) var(--spacer-4, 1rem) var(--spacer-4, 1rem) var(--spacer-4, 1rem);
      }

      .modal-header {
        padding: var(--spacer-3, 0.75rem) var(--spacer-4, 1rem);
      }

      form {
        padding: var(--spacer-3, 0.75rem) var(--spacer-4, 1rem);
      }

      .modal-policy {
        padding: 0 var(--spacer-4, 1rem) var(--spacer-3, 0.75rem) var(--spacer-4, 1rem);
      }
    }
  `;

  static properties = {
    isLoading: { type: Boolean },
    isAuthenticated: { type: Boolean },
    productId: { type: String, attribute: "product-id" },
    product: { type: Object },
    selectedVariant: { type: Object },
    upcomingSubscription: { type: Object },
    eligibleForSubscription: { type: Boolean },
    eligibleForOneTimeUpsell: { type: Boolean },
    oneTimeUpsellPercentageOff: { type: Number },
    selectedOption: { type: String },
    selectedSellingPlan: { type: Object },
    showSuccessScreen: { type: Boolean },
    previouslyAddedProducts: { type: String },
    isAddingToSubscription: { type: Boolean },
    addToSubscriptionError: { type: String },
    isReactivation: { type: Boolean },
    hasActiveSubscriptionForVariant: { type: Boolean },
    cancelledSubscription: { type: Object },
    allSubscriptionsContext: { type: Array },
  };

  constructor() {
    super();
    this.initializeDefaultState();
  }

  async connectedCallback() {
    super.connectedCallback();
    await this.initialize();
    this.isLoading = false;
    this.bindFormEvents();
  }

  initializeDefaultState() {
    this.isLoading = false;
    this.eligibleForSubscription = false;
    this.eligibleForOneTimeUpsell = false;
    this.selectedOption = "subscription";
    this.showSuccessScreen = false;
    this.isAddingToSubscription = false;
    this.addToSubscriptionError = null;
    this.isReactivation = false;
    this.hasActiveSubscriptionForVariant = false;
    this.cancelledSubscription = null;
    this.allSubscriptionsContext = [];
  }

  async initialize() {
    this.checkAuthentication();
    if (!this.isAuthenticated) return;

    // Fetch all required context concurrently to significantly optimize load time
    const [product, subscription, allSubs] = await Promise.all([
      this.fetchProduct(),
      this.fetchUpcomingSubscription(),
      this.fetchAllSubscriptionsContext()
    ]);

    this.product = product;
    this.upcomingSubscription = subscription;
    this.allSubscriptionsContext = allSubs;

    // Ensure selectedVariant is set after fetching product data
    const parentForm = this.closest('form') || this.closest('product-form-component') || this.closest('dose-buybox-selector');
    const variantInput = (parentForm ? parentForm.querySelector("[name=id]") : null) || document.querySelector("[name=id]");
    if (variantInput) {
      this.updateSelectedVariant(variantInput.value);
      if (this.selectedVariant) {
        this.checkVariantEligibility(this.selectedVariant);
        this.checkPreviouslyAddedProducts();
      }
    }
  }

  checkAuthentication() {
    this.isAuthenticated = !!window.Skio?.storefrontUser?.idToken;
  }

  async fetchUpcomingSubscription() {
    const query = `
      query storefrontGetUpcomingSubscription($storefrontUserId: uuid) {
        Subscriptions(where: {
          status: {
            _eq: "ACTIVE"
          }
          storefrontUserId: {
            _eq: $storefrontUserId
          }
        }, order_by: {
          nextBillingDate: asc
        }, limit: 1) {
          id
          status
          nextBillingDate
          SubscriptionLines(
            where: { removedAt: { _is_null: true } }
            limit: 1
            order_by: { createdAt: asc }
          ) {
            titleOverride
            ProductVariant {
              platformId
              title
              Product {
                title
              }
            }
            OriginalSellingPlan {
              PricingPolicies {
                percentageOff
                fixedPrice
              }
            }
          }
          DeliveryPolicy { 
            interval
            intervalCount
          }
          BillingPolicy {
            interval
            intervalCount
          }
        }
      }
    `;

    const variables = {
      storefrontUserId: window.Skio?.storefrontUser?.id,
    };

    try {
      const response = await window.Skio.graphQLRequest({ query, variables });
      const subscription = response.data?.Subscriptions?.[0];

      if (subscription && this.isPrepaidSubscription(subscription)) {
        return null;
      }

      return subscription;
    } catch (error) {
      console.error("Error fetching upcoming subscription:", error);
      return null;
    }
  }

  async fetchAllSubscriptionsContext() {
    const query = `
      query storefrontGetAllSubscriptionsContext($storefrontUserId: uuid) {
        Subscriptions(where: {
          storefrontUserId: { _eq: $storefrontUserId }
        }) {
          id
          status
          nextBillingDate
          DeliveryPolicy {
            interval
            intervalCount
          }
          BillingPolicy {
            interval
            intervalCount
          }
          SubscriptionLines(where: { removedAt: { _is_null: true } }) {
            id
            titleOverride
            ProductVariant {
              platformId
              title
              Product {
                title
              }
            }
            OriginalSellingPlan {
              platformId
              PricingPolicies {
                percentageOff
                fixedPrice
              }
            }
          }
        }
      }
    `;
    const variables = {
      storefrontUserId: window.Skio?.storefrontUser?.id,
    };

    try {
      const response = await window.Skio.graphQLRequest({ query, variables });
      return response.data?.Subscriptions || [];
    } catch (error) {
      console.error("Error fetching all subscriptions context:", error);
      return [];
    }
  }

  async fetchProduct() {
    const query = `
      query Products($where: Product_bool_exp) {
        Products(where: $where) {
          title
          canUpsell
          oneTimeUpsellPercentageOff
          ProductVariants {
            id
            title
            enableOneTimeUpsell
            platformId
            price
            compareAtPrice
            SellingPlanGroupResources(where: {SellingPlanGroup: { name: { _eq: "Subscription" } }}) {
              SellingPlanGroup {
                id
                customName
                SellingPlans {
                  id
                  platformId
                  PricingPolicies {
                    percentageOff
                    fixedPrice
                  }
                  DeliveryPolicy {
                    interval
                    intervalCount
                  }
                }
              }
            }
          }
        }
      }
    `;

    const variables = {
      where: {
        platformId: {
          _eq: `gid://shopify/Product/${this.productId}`,
        },
      },
    };

    try {
      const response = await window.Skio.graphQLRequest({ query, variables });
      return response.data?.Products?.[0];
    } catch (error) {
      console.error("Error fetching product:", error);
      return null;
    }
  }

  isPrepaidSubscription(subscription) {
    const { DeliveryPolicy, BillingPolicy } = subscription;
    return (
      DeliveryPolicy.interval !== BillingPolicy.interval ||
      DeliveryPolicy.intervalCount !== BillingPolicy.intervalCount
    );
  }

  formatDate(timestamp) {
    const date = new Date(timestamp);
    return `${date.toLocaleString("en-US", {
      month: "short",
    })} ${date.getDate()}, ${date.getFullYear()}`;
  }

  formatMoney(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  }

  bindFormEvents() {
    const parentForm = this.closest('form') || this.closest('product-form-component') || this.closest('dose-buybox-selector');
    const variantInput = (parentForm ? parentForm.querySelector("[name=id]") : null) || document.querySelector("[name=id]");
    if (variantInput) {
      this.updateSelectedVariant(variantInput.value);
      if (this.selectedVariant) {
        this.checkVariantEligibility(this.selectedVariant);
        this.checkPreviouslyAddedProducts();
      }

      variantInput.addEventListener("change", (e) => {
        this.updateSelectedVariant(e.target.value);
        if (this.selectedVariant) {
          this.checkVariantEligibility(this.selectedVariant);
          this.checkPreviouslyAddedProducts();
        }
      });
    }

    // Section or component variant change listeners
    const target = this.closest('.shopify-section, dialog, product-card, dose-buybox-selector') || document.querySelector('.shopify-section') || document;

    // Horizon specific variant:update listener
    target?.addEventListener('variant:update', (e) => {
      if (e.detail?.resource?.id) {
        this.updateSelectedVariant(e.detail.resource.id.toString());
        if (this.selectedVariant) {
          this.checkVariantEligibility(this.selectedVariant);
          this.checkPreviouslyAddedProducts();
        }
      }
    });

    // Dose buybox specific variant:change listener
    target?.addEventListener('variant:change', (e) => {
      const variantId = e.detail?.variant?.id || e.detail?.resource?.id;
      if (variantId) {
        this.updateSelectedVariant(variantId.toString());
        if (this.selectedVariant) {
          this.checkVariantEligibility(this.selectedVariant);
          this.checkPreviouslyAddedProducts();
        }
      }
    });
  }

  checkPreviouslyAddedProducts() {
    let previouslyAddedProducts =
      window.sessionStorage.getItem("skio_upsell_added_products") || "";
    if (previouslyAddedProducts.includes(this.selectedVariant?.platformId)) {
      this.showSuccessScreen = true;
    } else {
      this.showSuccessScreen = false;
    }
  }

  updateSelectedVariant(variantId) {
    if (!this.product || !this.product.ProductVariants || !variantId) return;
    this.selectedVariant = this.product.ProductVariants.find((variant) =>
      variant.platformId.includes(variantId)
    );
  }

  checkVariantEligibility(variant) {
    if (!variant) return;

    this.eligibleForOneTimeUpsell =
      Boolean(variant.enableOneTimeUpsell && this.product?.canUpsell);

    this.eligibleForSubscription = (variant.SellingPlanGroupResources || []).length > 0;

    if (!this.eligibleForOneTimeUpsell) {
      this.selectedOption = "subscription";
    }

    // Check the state of the subscriptions for this variant
    this.isReactivation = false;
    this.hasActiveSubscriptionForVariant = false;
    this.cancelledSubscription = null;

    if (this.allSubscriptionsContext && this.allSubscriptionsContext.length > 0) {
      for (const sub of this.allSubscriptionsContext) {
        // Check if any SubscriptionLine matches the currently selected variant and is a recurring item
        const hasRecurringVariant = sub.SubscriptionLines?.some(
          (line) => line.ProductVariant?.platformId === variant.platformId && line.OriginalSellingPlan !== null
        );
        if (hasRecurringVariant) {
          if (sub.status === "ACTIVE") {
            this.hasActiveSubscriptionForVariant = true;
          } else if (sub.status === "CANCELLED") {
            this.isReactivation = true;
            this.cancelledSubscription = sub;
          }
        }
      }
    }
  }

  get activeDiscountPercent() {
    const attrDiscount = parseFloat(this.getAttribute("data-manual-discount")) || 0;
    const picker = document.querySelector("dose-skio-plan-picker");
    const pickerDiscount = picker ? parseFloat(picker.getAttribute("data-manual-discount")) || 0 : 0;
    const urlParams = new URLSearchParams(window.location.search);
    const sessionDiscount = parseFloat(urlParams.get("discount_value")) || window.SkioSessionDiscount || 0;
    return Math.max(attrDiscount, pickerDiscount, sessionDiscount);
  }

  get activeDiscountText() {
    const attrText = this.getAttribute("data-discount-text");
    if (attrText) return attrText;
    if (window.SkioSessionDiscountText) return window.SkioSessionDiscountText;
    const percent = this.activeDiscountPercent;
    return percent > 0 ? `${percent}%` : null;
  }

  getSubscriptionPrice() {
    const sellingPlanGroup = this.findMatchingSellingPlanGroup();
    const sellingPlan = this.findMatchingSellingPlan(sellingPlanGroup);

    if (!sellingPlan)
      return {
        discount: null,
        price: this.formatMoney(this.selectedVariant?.price || 0),
      };

    this.selectedSellingPlan = sellingPlan;

    const pricingPolicy = sellingPlan.PricingPolicies?.[0];
    let discount, price;

    const overridePercent = this.activeDiscountPercent;
    const overrideText = this.activeDiscountText;

    if (overridePercent > 0 || overrideText) {
      const percent = overridePercent || parseFloat(overrideText) || 0;
      discount = overrideText || (percent > 0 ? `${percent}%` : null);
      price = percent > 0
        ? this.selectedVariant.price * (1 - percent / 100)
        : this.selectedVariant.price;
    } else if (pricingPolicy?.percentageOff) {
      discount = `${pricingPolicy.percentageOff}%`;
      price =
        this.selectedVariant.price * (1 - pricingPolicy.percentageOff / 100);
    } else if (pricingPolicy?.fixedPrice) {
      discount = this.formatMoney(pricingPolicy.fixedPrice);
      price = this.selectedVariant.price - pricingPolicy.fixedPrice;
    }

    return {
      discount,
      price: this.formatMoney(price || this.selectedVariant?.price || 0),
    };
  }

  getOneTimePrice() {
    if (!this.product?.oneTimeUpsellPercentageOff) {
      return {
        discount: null,
        price: this.formatMoney(this.selectedVariant?.price || 0),
      };
    }

    const discount = `${this.product.oneTimeUpsellPercentageOff * 100}%`;
    const price =
      this.selectedVariant.price *
      (1 - this.product.oneTimeUpsellPercentageOff);

    return {
      discount,
      price: this.formatMoney(price),
    };
  }

  findMatchingSellingPlanGroup() {
    if (!this.selectedVariant?.SellingPlanGroupResources || !this.upcomingSubscription?.DeliveryPolicy) return null;
    return this.selectedVariant.SellingPlanGroupResources.find((group) =>
      group.SellingPlanGroup.SellingPlans.some((plan) =>
        this.isMatchingDeliveryPolicy(plan.DeliveryPolicy)
      )
    );
  }

  findMatchingSellingPlan(sellingPlanGroup) {
    if (!sellingPlanGroup) return null;

    return sellingPlanGroup.SellingPlanGroup.SellingPlans.find((plan) =>
      this.isMatchingDeliveryPolicy(plan.DeliveryPolicy)
    );
  }

  isMatchingDeliveryPolicy(deliveryPolicy) {
    if (!deliveryPolicy || !this.upcomingSubscription?.DeliveryPolicy) return false;
    return (
      deliveryPolicy.interval ===
      this.upcomingSubscription.DeliveryPolicy.interval &&
      deliveryPolicy.intervalCount ===
      this.upcomingSubscription.DeliveryPolicy.intervalCount
    );
  }

  async addToSubscription() {
    // Clear any previous errors and set loading state
    this.addToSubscriptionError = null;
    this.isAddingToSubscription = true;

    const variantId = this.selectedVariant.id || this.selectedVariant.platformId;
    const isOneTimeUpsell = this.selectedOption === "one-time";
    const subscriptionId = this.upcomingSubscription.id;

    // Calculate custom price if active promo discount percent is present for subscription
    const activeDiscount = this.activeDiscountPercent;
    let customPrice;
    if (activeDiscount > 0 && !isOneTimeUpsell && this.selectedVariant?.price) {
      customPrice = Number((this.selectedVariant.price * (1 - activeDiscount / 100)).toFixed(2));
    } else if (isOneTimeUpsell && this.product?.oneTimeUpsellPercentageOff && this.selectedVariant?.price) {
      customPrice = Number((this.selectedVariant.price * (1 - this.product.oneTimeUpsellPercentageOff)).toFixed(2));
    }

    const mutation = `
      mutation storefrontAddSubscriptionLine($input: AddSubscriptionLineInput!) {
        addSubscriptionLine(input: $input) {
          ok
        }
      }
    `;

    const input = {
      subscriptionId,
      variantId,
      quantity: 1,
      upsell: isOneTimeUpsell,
    };

    if (customPrice !== undefined) {
      input.price = customPrice;
    }

    const variables = {
      input,
    };

    try {
      const response = await window.Skio.graphQLRequest({
        query: mutation,
        variables,
      });

      // Close modal and show success screen
      this.closeModal();
      let previouslyAddedProducts =
        window.sessionStorage.getItem("skio_upsell_added_products") || "";
      window.sessionStorage.setItem(
        "skio_upsell_added_products",
        `${previouslyAddedProducts}, ${this.selectedVariant.platformId}`
      );

      this.showSuccessScreen = true;

      return response;
    } catch (error) {
      console.error("Error adding to subscription:", error);
      this.addToSubscriptionError = "Error adding to subscription. Please try again.";
      return error;
    } finally {
      this.isAddingToSubscription = false;
    }
  }

  openModal() {
    const dialog = this.shadowRoot.querySelector("dialog");
    if (dialog) {
      dialog.showModal();
      this.setupModalEventListeners(dialog);
    }
  }

  closeModal() {
    const dialog = this.shadowRoot.querySelector("dialog");
    if (dialog) {
      dialog.close();
      this.removeModalEventListeners(dialog);
    }
  }

  setupModalEventListeners(dialog) {
    dialog.addEventListener("click", this.handleBackdropClick.bind(this));
  }

  removeModalEventListeners(dialog) {
    dialog.removeEventListener("click", this.handleBackdropClick.bind(this));
  }

  handleBackdropClick(e) {
    if (e.target.tagName === "DIALOG") {
      this.closeModal();
    }
  }

  renderModal() {
    const oneTimePrice = this.getOneTimePrice();
    const subscriptionPrice = this.getSubscriptionPrice();

    let itemsString = "";
    if (this.upcomingSubscription?.SubscriptionLines) {
      const lines = this.upcomingSubscription.SubscriptionLines.filter(line => line.OriginalSellingPlan !== null);
      itemsString = lines.map(line => {
        if (line.titleOverride) return line.titleOverride;
        const prodTitle = line.ProductVariant?.Product?.title || '';
        const varTitle = line.ProductVariant?.title && line.ProductVariant.title !== 'Default Title' ? `- ${line.ProductVariant.title}` : '';
        return `${prodTitle} ${varTitle}`.trim();
      }).filter(Boolean).join(", ");
    }

    return html`
      <dialog>
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">
              Add to Subscription
            </h2>           
            <button class="close-button" @click=${this.closeModal}>
              &times;
            </button>
            ${itemsString ? html`<p class="skio-subscription-items">Your Subscription Items: ${itemsString}</p>` : ''}
            <span class="date-badge">
            Next order on: ${this.formatDate(
      this.upcomingSubscription.nextBillingDate
    )}</span>
          </div>
          <form>
            ${this.addToSubscriptionError
        ? html`<div class="error-message">${this.addToSubscriptionError}</div>`
        : null}
            ${this.eligibleForOneTimeUpsell
        ? this.renderOneTimeOption(oneTimePrice)
        : null}
            ${this.eligibleForSubscription
        ? this.renderSubscriptionOption(subscriptionPrice)
        : null}
          </form>
            
          <div class="modal-policy">
            ${this.selectedOption === 'subscription' ?
        html`<small>By clicking Add to Order, you’re adding this item to your subscription. You’ll be charged automatically at the listed price and frequency until canceled. All cancellations are subject to the <a href="/policies/subscription-policy">cancellation policy</a>.</small>`
        : html`<small>By selecting Add to Order, you agree to a one-time charge for this item, which will be added to your next subscription shipment. This item will not renew or be billed again. All cancellations are subject to the <a href="/policies/subscription-policy">cancellation policy</a>.</small>`}
          </div>
          
          <div class="modal-footer">
            <button 
              class="primary-button" 
              @click=${this.addToSubscription}
              ?disabled=${this.isAddingToSubscription}
            >
              ${this.isAddingToSubscription
        ? html`<span class="loading-spinner"></span>`
        : "ADD TO ORDER"}
            </button>
            <button
              class="secondary-button"
              @click=${this.closeModal}
              type="button"
              ?disabled=${this.isAddingToSubscription}
            >
              Cancel
            </button>
          </div>
        </div>
      </dialog>
    `;
  }

  renderOneTimeOption(oneTimePrice) {
    const isSelected = this.selectedOption === "one-time";

    return html`
      <label
        class="option-label ${isSelected ? "selected" : ""}"
        @click=${() => (this.selectedOption = "one-time")}
      >
        <input
          type="radio"
          name="addType"
          value="one-time"
          .checked=${isSelected}
          @change=${() => (this.selectedOption = "one-time")}
        />
        <div class="option-content">
          <span class="option-title">Get One-Time</span>
        </div>
        ${oneTimePrice.discount
        ? html`<span class="discount-badge"
                >Save ${oneTimePrice.discount}</span
              >`
        : null}
        <div class="price-container">
          ${this.getOriginalPrice() === oneTimePrice.price ? null : html`<span class="original-price"> ${this.getOriginalPrice()} </span>`}
          <span class="discounted-price">${oneTimePrice.price}</span>
        </div>
      </label>
    `;
  }

  renderSubscriptionOption(subscriptionPrice) {
    const isSelected = this.selectedOption === "subscription";

    return html`
      <label
        class="option-label ${isSelected ? "selected" : ""}"
        @click=${() => (this.selectedOption = "subscription")}
      >
        <input
          type="radio"
          name="addType"
          value="subscription"
          .checked=${isSelected}
          @change=${() => (this.selectedOption = "subscription")}
        />
        <div class="option-content">
          <span class="option-title">Subscribe</span>
          <div class="delivery-policy">
            Every ${this.upcomingSubscription.DeliveryPolicy.intervalCount}
            ${this.upcomingSubscription.DeliveryPolicy.interval.toLowerCase()}
          </div>
        </div>
        ${subscriptionPrice.discount
        ? html`<span class="discount-badge"
                >${subscriptionPrice.discount.toLowerCase().startsWith("save")
            ? subscriptionPrice.discount
            : `Save ${subscriptionPrice.discount}`}</span
              >`
        : null}
        <div class="price-container">
          ${this.getOriginalPrice() === subscriptionPrice.price ? null : html`<span class="original-price"> ${this.getOriginalPrice()} </span>`}
          <span class="discounted-price">${subscriptionPrice.price}</span>
        </div>
      </label>
    `;
  }

  getOriginalPrice() {
    return this.selectedVariant?.compareAtPrice
      ? this.formatMoney(this.selectedVariant.compareAtPrice)
      : this.formatMoney(this.selectedVariant?.price || 0);
  }

  renderSuccessScreen() {
    return html`
      <div class="success-screen">
        <h2 class="success-title">Added to Your Next Order</h2>
        <p class="success-message">
          This item will be included in your next subscription order shipment on
          <span class="success-date"
            >${this.formatDate(this.upcomingSubscription.nextBillingDate)}</span
          >
        </p>
        <a href="/a/account/subscriptions" class="success-link">
          View and manage my subscriptions ->
        </a>
      </div>
    `;
  }

  render() {
    if (!this.shouldRender()) {
      return null;
    }

    if (this.isReactivation) {
      let itemsString = "";
      if (this.cancelledSubscription?.SubscriptionLines) {
        const lines = this.cancelledSubscription.SubscriptionLines.filter(line => line.OriginalSellingPlan !== null);
        itemsString = lines.map(line => {
          if (line.titleOverride) return line.titleOverride;
          const prodTitle = line.ProductVariant?.Product?.title || '';
          const varTitle = line.ProductVariant?.title && line.ProductVariant.title !== 'Default Title' ? `- ${line.ProductVariant.title}` : '';
          return `${prodTitle} ${varTitle}`.trim();
        }).filter(Boolean).join(", ");
      }

      return html`
              <div class="callout">
                <h3>Reactivate Subscription</h3>
                <small>You previously had a subscription for this item.</small>
                ${itemsString ? html`<p class="skio-subscription-items">Your cancelled subscription contains: <strong>${itemsString}</strong></p>` : ''}
                <p>
                  Would you like to reactivate it?
                </p>
                <a 
                  href="/a/account/subscriptions" 
                  class="add-to-subscription-button"
                >
                  Reactivate Subscription
                </a>
              </div>
            `;
    }

    // Show success screen if item was added successfully
    if (this.showSuccessScreen) {
      return this.renderSuccessScreen();
    }

    const subscriptionPrice = this.getSubscriptionPrice();
    const originalPrice = this.getOriginalPrice();

    let badgeText = "";
    if (subscriptionPrice.discount) {
      const rawDiscount = subscriptionPrice.discount.trim();
      if (rawDiscount.toLowerCase().startsWith("get") || rawDiscount.toLowerCase().startsWith("save")) {
        badgeText = rawDiscount;
      } else if (rawDiscount.endsWith("%")) {
        badgeText = `Get ${rawDiscount} Off`;
      } else {
        badgeText = `Get ${rawDiscount} Off`;
      }
    }

    return html`
      <div class="callout">
        <div class="callout-header">
          <div class="callout-title-group">
            <h3 class="callout-title">Add to upcoming subscription order</h3>
            <p class="callout-date">
              Next order on ${this.formatDate(this.upcomingSubscription.nextBillingDate)}.
            </p>
          </div>
          <div class="callout-pricing-group">
            ${badgeText ? html`<span class="callout-badge">${badgeText}</span>` : ""}
            <div class="callout-prices">
              ${originalPrice !== subscriptionPrice.price ? html`<span class="callout-price-old">${originalPrice}</span>` : ""}
              <span class="callout-price-new">${subscriptionPrice.price}</span>
            </div>
          </div>
        </div>

        <button
          class="add-to-subscription-button"
          @click=${() => this.openModal()}
        >
          Add to upcoming order
        </button>
      </div>

      ${this.renderModal()}
    `;
  }

  shouldRender() {
    if (!window.location.pathname.includes('/products/')) {
      return false;
    }

    // Do not render if they already have an active subscription for this exact product variant
    if (this.hasActiveSubscriptionForVariant) {
      return false;
    }

    // If we are eligible for reactivation, we only need auth, eligibility, and the selected variant
    if (this.isReactivation) {
      return Boolean(
        this.isAuthenticated &&
        this.eligibleForSubscription &&
        this.selectedVariant &&
        this.cancelledSubscription
      );
    }

    // Otherwise, standard add-to-order requires an active upcoming subscription
    return Boolean(
      this.isAuthenticated &&
      this.upcomingSubscription &&
      this.eligibleForSubscription &&
      this.selectedVariant
    );
  }
}

if (!customElements.get("skio-add-to-subscription")) {
  customElements.define("skio-add-to-subscription", SkioAddToSubscription);
}
